import React from "react";
import {Row} from "reactstrap";
import {Link} from 'react-router-dom';
import './styles.scss'

const PageHeader=({title,breadcrumbItem})=>{
  return(
    <Row>
      <div className='col-md-12'>
        <div className="page-header">
          <div>
            <h2 className="main-content-title tx-24 mg-b-5">{title}</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page">{breadcrumbItem}</li>
            </ol>
          </div>
          {
            /*
            <div className="d-flex">
            <div className="justify-content-center">
              <button type="button" className="btn btn-white btn-icon-text my-2 mr-2">
                <i className="fe fe-download mr-2"></i> Import
              </button>
              <button type="button" className="btn btn-white btn-icon-text my-2 mr-2">
                <i className="fe fe-filter mr-2"></i> Filter
              </button>
              <button type="button" className="btn btn-primary my-2 btn-icon-text">
                <i className="fe fe-download-cloud mr-2"></i> Download Report
              </button>
            </div>
          </div>
           */
          }
        </div>
      </div>
    </Row>

  )
}

export default PageHeader;
